import { PATHS } from 'src/common/constants';
import { SidebarContextRow } from '../Components/SidebarContextTree';

const THREE_PART_COMPOSITE_LENGTH = 3;
const SUITE_ID_PART = 1;
const PROPERTY_ID_PART_TWO_PART = 0; // 2-part id: `propertyId&suiteId`
const PROPERTY_ID_PART_THREE_PART = 2; // 3-part id: `x&suiteId&propertyId`

/* legacy/workaround: BOS encodes the suite route id as a `&`-joined composite. The
 * suiteId is always the 2nd part; the propertyId is the 3rd on a 3-part id, else the 1st.
 * Mirrors useSuitePageData */
export const parseSuiteRouteId = (
  rawId: string
): { suiteId: string; propertyId: string } => {
  const parts: string[] = rawId.split('&');

  const isThreePartComposite: boolean =
    parts.length === THREE_PART_COMPOSITE_LENGTH;

  const suiteId: string = parts[SUITE_ID_PART] ?? '';

  const propertyId: string = isThreePartComposite
    ? parts[PROPERTY_ID_PART_THREE_PART]
    : parts[PROPERTY_ID_PART_TWO_PART];

  return { suiteId, propertyId };
};

export const suiteRow = (
  suiteRouteId: string,
  suiteNumber: string | null
): SidebarContextRow => ({
  label: suiteNumber ?? '',
  path: PATHS.SUITES_VIEW.replace(':id', suiteRouteId),
  icon: 'home',
  depth: 1,
  loading: !suiteNumber,
});

export const assetRow = (
  assetRouteId: string,
  assetName: string | null
): SidebarContextRow => ({
  label: assetName ?? '',
  path: PATHS.ASSETS_VIEW.replace(':id', assetRouteId),
  icon: 'box',
  depth: 2,
  loading: !assetName,
});

export const keyPickupRow = (suiteRouteId: string): SidebarContextRow => ({
  label: 'Key pickup',
  path: PATHS.KEY_PICKUP_VIEW.replace(':id', suiteRouteId),
  icon: 'key',
  depth: 2,
});